import './policy.css';

const UserTerms = () => {
	return (
		<div className="policy-container">
			<div className="title-container">
				<div className="policy-title">
					User Account &amp; Wallet Terms (Last updated: 7-Apr-2026)
				</div>
			</div>

			<div className="policy-content-container">
				<p>
					These User Account Terms specifically govern the financial and
					operational aspects of your LOCKA account, including digital
					wallet transactions, locker rentals, and account lifecycle
					management. By using LOCKA, you expressly agree to these terms.
				</p>

				<h3>1. Digital Wallet &amp; Payments</h3>
				<p>
					LOCKA provides a digital wallet ("Wallet") to facilitate seamless
					locker rentals.
				</p>
				<ul>
					<li>
						<strong>Wallet Top-ups:</strong> You may add credits to your
						Wallet via our third-party processor, Stripe. Once a top-up is
						successful, funds are converted to LOCKA credits. These
						credits have no cash value outside of the LOCKA platform.
					</li>
					<li>
						<strong>Non-Refundable Credits:</strong> Wallet top-ups are
						non-refundable to the original payment method once the credit
						has been issued to your account, except where required by
						local consumer law.
					</li>
					<li>
						<strong>Withdrawal Policy:</strong> You may request to
						withdraw your remaining balance to a verified bank account.{' '}
						<strong>
							A 2% handling fee will be deducted from your balance for
							each withdrawal transaction.
						</strong>
					</li>
					<li>
						<strong>Accuracy of Information:</strong> You are solely
						responsible for ensuring your bank account details are
						correct. LOCKA SPACE LIMITED is not liable for funds lost or
						delayed due to incorrect information provided by the user.
					</li>
				</ul>

				<h3>2. Locker Rental &amp; Usage</h3>
				<p>
					By initiating a rental session through the app, you authorize
					LOCKA to deduct the applicable fees from your Wallet balance.
				</p>
				<ul>
					<li>
						<strong>Extended Usage Charges:</strong> If a locker remains
						occupied beyond the initial period or intended duration,
						additional charges may apply at the then-current rates. You
						are responsible for ensuring your Wallet has sufficient
						credits to cover the total duration of use.
					</li>
					<li>
						<strong>Unclaimed Items:</strong> LOCKA reserves the right to
						manage and clear lockers that are deemed abandoned or remain
						occupied significantly beyond the allowed rental period. Items
						removed from lockers may be disposed of or stored elsewhere at
						LOCKA's discretion.
					</li>
					<li>
						<strong>Prohibited Items:</strong> You may not store illegal,
						hazardous, flammable, or perishable items. Violation of this
						rule will result in immediate account termination without a
						refund.
					</li>
				</ul>

				<h3>3. Limitation of Liability (Theft &amp; Damage)</h3>
				<p>
					<strong>PLEASE READ CAREFULLY:</strong> LOCKA SPACE LIMITED
					provides a facilitation service and hardware for storage. We do
					not provide insurance for your personal property.
				</p>
				<ul>
					<li>
						<strong>No Compensation for Loss:</strong> LOCKA is not
						responsible for any loss, theft, or disappearance of items
						stored in our lockers.
						<strong>
							{' '}
							In the event of theft or unauthorized access, LOCKA will
							not provide refunds or financial compensation for the value
							of the items.
						</strong>
					</li>
					<li>
						<strong>No Liability for Damage:</strong> LOCKA is not liable
						for physical damage to items caused by hardware malfunction,
						environmental conditions (moisture, temperature), or the
						actions of other users.
					</li>
					<li>
						<strong>Security Responsibility:</strong> You are responsible
						for verifying that the locker door is securely latched and
						locked before leaving the area. LOCKA is not liable for losses
						resulting from user failure to secure the locker properly.
					</li>
				</ul>

				<h3>4. Account Deletion &amp; Data Retention</h3>
				<p>
					You may request to delete your LOCKA account at any time via the
					app settings.
				</p>
				<ul>
					<li>
						<strong>30-Day Cooling-off Period:</strong> Upon requesting
						deletion, your account will enter a "Pending Deletion" state
						for a period of 30 days. During this time, your data is
						retained in our secure database but access to the app is
						restricted.
					</li>
					<li>
						<strong>Reversal:</strong> You may cancel a deletion request
						within the 30-day window by contacting our support team.
					</li>
					<li>
						<strong>Final Deletion:</strong> After 30 days, your personal
						data, transaction history, and any remaining Wallet balance
						will be permanently deleted from our servers.{' '}
						<strong>
							Once deleted, balances cannot be refunded or recovered.
						</strong>
					</li>
				</ul>

				<h3>5. Contact Us</h3>
				<p>
					If you have questions regarding your balance, a failed
					withdrawal, or to report a technical issue with a locker, please
					contact us at:
				</p>
				<p>
					<strong>Email:</strong> cs@locka.space
				</p>
			</div>
		</div>
	);
};

export default UserTerms;
